import { usePostApiTimesheets, } from '../../generated/sitComponents';
import { invalidateTimesheetsQuery } from '../timesheets/query';
export function usePostTimesheet(options) {
    // TODO: write reasonable invalidations here. Also, introduce a query cache mechanism that remembers what companyId this timesheet was created on.
    // That way, `GET /api/dimensions` can use the mapping from `timesheetId` to `companyId` to use proper caching mechanisms.
    return usePostApiTimesheets({
        ...options,
        onSuccess: async (data, variables, onMutateResult, context) => {
            await invalidateTimesheetsQuery(context.client);
            await options?.onSuccess?.(data, variables, onMutateResult, context);
        },
    });
}
//# sourceMappingURL=use-post-timesheet.js.map